import {createFileRoute, redirect} from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: IndexPage,
  beforeLoad: () => {
    throw redirect({to: '/patient-dashboard'})
  },
})

function IndexPage() {
  return null
}
